const PROMO_LOCALSTORE_KEY = 'bmPromos'; 
const Q_STRINGS = ['one', 'two', 'three'];
export const PROMO_SKUS = [
  '170433', 
  '170434', 
  '170435',
];

const BM_PROMOS = {
  one : {
    sku: '170433',
    tierName: 'lite',
    promoWeight: 1
  },
  two: {
    sku: '170434',
    tierName: 'basic',
    promoWeight: 2
  },
  three: {
    sku: '170435',
    tierName: 'plus',
    promoWeight: 3
  }
};

export const setBmPromoValues = (promoString) => {
  //Exit if not an acceptable querystring
  if (!Q_STRINGS.includes(promoString)) return;

  if(localStorage.getItem(PROMO_LOCALSTORE_KEY) === null) {
    localStorage.setItem(PROMO_LOCALSTORE_KEY, JSON.stringify([BM_PROMOS[promoString]]));
  } else {
    const mergedPromos = JSON.parse(localStorage.getItem(PROMO_LOCALSTORE_KEY));
    
    // Merge in the promo if it doesn't already exist in the localstorage key
    if (! (mergedPromos.some(e => e.tierName === BM_PROMOS[promoString].tierName)) ) {
      mergedPromos.push(BM_PROMOS[promoString]);
      localStorage.setItem(PROMO_LOCALSTORE_KEY, JSON.stringify(mergedPromos));
    }
  }
};

// Currently we only show a single promo at a time so this returns all promo skus if they've got none
// in localStorage if there's multiple find the best promo and remove it from the list of skus to ignore
export const getSkusToHide = () => {
  // If they have nothing in localstore they aren't 'eldgible' from 
  if (localStorage.getItem(PROMO_LOCALSTORE_KEY) === null) return PROMO_SKUS;

  const promosAvailable = JSON.parse(localStorage.getItem(PROMO_LOCALSTORE_KEY));
  let bestPromotion = null;

  promosAvailable.forEach(promo => {
    if (!bestPromotion) {
      bestPromotion = promo;
    } else if (bestPromotion) {
      if (bestPromotion.promoWeight < promo.promoWeight) {
        bestPromotion = promo;
      }
    }
  });

  return PROMO_SKUS.filter(sku => sku != bestPromotion.sku);
};